let counter = 0;
export const generateId = (prefix) => `${prefix}-${Date.now()}-${++counter}`;
